import { BrandEntity } from '../../../../models';
import { UlItem } from '../../../../models/ui.interfaces';
import {
  CheckInEntity,
  MedallionEntity,
  MytripsEntity,
  MytripsLoggedIn,
  NavigationEntity,
  PassengersEntity,
  ToolTipDetailsEntity,
  TripTypeEntity
} from './header.entity.interfaces';

/** Holds content that display on "MY TRIP" primary navigation on header */
export interface MyTripNavigation {
  mytripsLastName?: string | null;
  mytripLastNameFloat?: string | null;
  mytripsHotelReservationUrl?: string | null;
  mytripsHotelReservationLabel?: string | null;
  mytripsWhereToFindUrl?: string | null;
  mytripsWhereToFindLabel?: string | null;
  mytripsFirstName?: string | null;
  mytripsFirstNameFloat?: string | null;
  backToUpcomingTripLabel?: string | null;
  mytripsHotelReservationTarget?: string | null;
  mytrips?: MytripsEntity[] | null;
  mytripsLoggedIn?: MytripsLoggedIn | null;
}

/** Holds Primary Navigation content  E.g., "BOOK", "CHECKIN", "MY TRIPS" & "FLIGHT STATUS" */
export interface PrimaryNavigationEntity
  extends NavigationEntity,
    MyTripNavigation {
  departLabel?: string | null;
  returnLabel?: string | null;
  advancedSearchLabel?: string | null;
  fromLabel?: string | null;
  travelOrigin?: string | null;
  toLabel?: string | null;
  travelDestinationLabel?: string | null;
  meetingCode?: string | null;
  flightPlusHotelLabel?: string | null;
  flightPlusHotelIntercept?: string | null;
  flightplushotelduration?: string | null;
  meetingCodeFloatingLabel?: string | null;
  edpMeetingCodeDisclaimer?: string | null;
  edpMeetingCodeDisclaimerForFare?: string | null;
  edpMeetingCodeDisclaimerForProgram?: string | null;
  edpMeetingCodeDisclaimerForNoProgram?: string | null;
  moneyLabel?: string | null;
  milesPlusMoneyLabel?: string | null;
  showprice?: string | null;
  bestFareLabel?: string | null;
  searchByFareClassLabel?: string | null;
  showHideSearchByFareClass?: string | null;
  refundableFareLabel?: string | null;
  nearByAirports?: string | null;
  milesLabel?: string | null;
  toggleMiles?: string | null;
  ecertLabel?: string | null;
  ecertUrl?: string | null;
  newWindow?: string | null;
  multicityFromLabel?: string | null;
  multicityToLabel?: string | null;
  multicityDepartLabel?: string | null;
  connectionLabel?: string | null;
  connectionFloatingLabel?: string | null;
  addFlightLabel?: string | null;
  removeFlightLabel?: string | null;
  submitUrl: string;
  legacyAppUrl: string;
  searchUrl: string;
  mobileSubmitUrl?: string | null;
  redirectMobile: string;
  redirectMobileUrl: string;
  flightLabel?: string | null;
  maxNumberOfPax?: string | null;
  tripType?: TripTypeEntity[] | null;
  passengers?:
    | (UlItem & PassengersEntity & MedallionEntity & BrandEntity)[]
    | null;
  brand?: (UlItem & BrandEntity)[] | null;
  toolTipDetails?: ToolTipDetailsEntity[] | null;
  milesMobileRedirect?: string | null;
  altSearchLabel?: string | null;
  hideEditSearchLabel?: string | null;
  disablemultipax?: string | null;
  flexibleDates?: string | null;
  searchoptionLabel?: string | null;
  showFares?: string | null;
  mobileCheckMpm?: string | null;
  addDisableMetaSearch?: string | null;
  showSlimNavMultiCity?: boolean | null;
  fromAirport?: string | null;
  cinLastname?: string | null;
  fromAirportFloat?: string | null;
  floatlabelLastname?: string | null;
  findYourTripBy?: string | null;
  yourUpcomingTrip?: string | null;
  viewTripDetails?: string | null;
  viewTripDetailsNewTab?: string | null;
  viewBoardingPass?: string | null;
  viewBoardingPassNewTab?: string | null;
  checkinText?: string | null;
  checkinButtonNewTab?: string | null;
  findmytrip?: string | null;
  helpLabel?: string | null;
  helpUrl?: string | null;
  whereToFindLabel?: string | null;
  whereToFindUrl?: string | null;
  checkIn?: CheckInEntity[] | null;
  searchByLabel?: string | null;
  searchByLabelFloat?: string | null;
  flightNumber?: string | null;
  flightNumberType?: string | null;
  flightNumberLabelFloat?: string | null;
  orLabel?: string | null;
  toLabelFloat?: string | null;
  fromLabelFloat?: string | null;
  flightStatusSubmitUrl?: string | null;
  flightScheduleSubmitUrl?: string | null;
}
